'use client';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Grid, Typography, useMediaQuery } from '@mui/material';
import { useEffect, useState } from 'react';
import { AppConsts } from '../../../../application/common/constants/app-consts';
import { useLazyGetMachineDetailResultQuery, useLazyGetPaginatedFolderViewQuery } from '../../../../application/features/folder-view/folder-view-api';
import { setFolderViewRequest, setIsUpdateFolderGrid } from '../../../../application/features/folder-view/folderViewSlice';
import { useAppDispatch, useAppSelector } from '../../../../application/store/useStore';
import useTranslate from '../../../../localization/helpers';
import MachineFolderCard from './MachineFolder';
import ActivationDialog from './activation-dialog';
import FolderQuickView from './folder-quick-view';
var MachineFolders = function (_a) {
    var _b, _c, _d;
    var onMachineSelect = _a.onMachineSelect, getData = _a.getData, onViewDocuments = _a.onViewDocuments, onManageSerialNumbers = _a.onManageSerialNumbers, onStartChat = _a.onStartChat, setFAQDrawer = _a.setFAQDrawer, setTechnicianDrawer = _a.setTechnicianDrawer, setClientsDrawer = _a.setClientsDrawer, handleOpenEditMachine = _a.handleOpenEditMachine, openMachineActivationModal = _a.openMachineActivationModal, isUpdateFolder = _a.isUpdateFolder, searchText = _a.searchText, location = _a.location, selectedClients = _a.selectedClients, selectedMachines = _a.selectedMachines, selectedBrands = _a.selectedBrands;
    var translate = useTranslate().translate;
    var dispatch = useAppDispatch();
    var _e = __read(useState(null), 1), selectedMachine = _e[0];
    var _f = __read(useState(false), 2), dialogOpen = _f[0], setDialogOpen = _f[1];
    var _g = __read(useState(false), 2), quickViewDilaogOpen = _g[0], setQuickViewDialogOpen = _g[1];
    var _h = __read(useState(false), 1), isActivating = _h[0];
    var _j = __read(useState(null), 2), folderDocuments = _j[0], setFolderDocuments = _j[1];
    var _k = useAppSelector(function (state) { return state.folderView; }), folderViewRequest = _k.folderViewRequest, isUpdateFolderGrid = _k.isUpdateFolderGrid;
    var _l = __read(useLazyGetPaginatedFolderViewQuery(), 2), trigger = _l[0], _m = _l[1], data = _m.data, isFetching = _m.isFetching;
    var _o = __read(useLazyGetMachineDetailResultQuery(), 1), triggerMachineDetail = _o[0];
    useEffect(function () {
        dispatch(setFolderViewRequest(__assign(__assign({}, folderViewRequest), { clients: selectedClients, brands: selectedBrands, machines: selectedMachines })));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedClients, selectedBrands, selectedMachines, dispatch]);
    useEffect(function () {
        if (folderViewRequest) {
            trigger(folderViewRequest);
        }
    }, [folderViewRequest, trigger]);
    useEffect(function () {
        if (folderViewRequest) {
            trigger(folderViewRequest);
        }
    }, [folderViewRequest, isUpdateFolder, trigger]);
    useEffect(function () {
        if (folderViewRequest && isUpdateFolderGrid !== false) {
            trigger(folderViewRequest);
            dispatch(setIsUpdateFolderGrid(false));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, isUpdateFolderGrid]);
    useEffect(function () {
        if (searchText && searchText.length >= 2) {
            dispatch(setFolderViewRequest(__assign(__assign({}, folderViewRequest), { searchText: searchText })));
        }
        else if ((searchText === null || searchText === void 0 ? void 0 : searchText.length) === 0) {
            dispatch(setFolderViewRequest(__assign(__assign({}, folderViewRequest), { searchText: undefined })));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, searchText]);
    useEffect(function () {
        if (data) {
            getData(data.totalCount);
            setFolderDocuments(data);
        }
    }, [data, getData]);
    var isscreen600900 = useMediaQuery('(min-width:600px) and (max-width:900px)');
    var iscreen9001200 = useMediaQuery('(min-width:900px) and (max-width:1200px)');
    var isscreen9001200Landscape = useMediaQuery('(min-width:600px) and (max-width:900px) and (orientation: landscape)');
    var isscreen600900Landscape = useMediaQuery('(min-width:600px) and (max-width:900px) and (orientation: landscape)');
    var handleSwitchToggle = function (machineDocument) { return __awaiter(void 0, void 0, void 0, function () {
        var result, machine;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, triggerMachineDetail(machineDocument.id).unwrap()];
                case 1:
                    result = _a.sent();
                    machine = {
                        id: result.id,
                        companyId: result.companyId,
                        companyName: result.companyName,
                        name: result.name,
                        type: result.type,
                        technicians: result.technicians,
                        totalClients: result.totalClients,
                        processedDocuments: result.documents,
                        failedDocuments: 0,
                        processingDocuments: 0,
                        unprocessableDocuments: 0,
                        brand: result.brand,
                        isActive: result.isActive,
                        linkedFrom: []
                    };
                    openMachineActivationModal(machine, machineDocument.isActive);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleConfirmToggle = function () {
        setDialogOpen(false);
    };
    var handleStartChat = function (id) {
        onStartChat(id);
    };
    var handleViewTechnicians = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var result, machine;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, triggerMachineDetail(id).unwrap()];
                case 1:
                    result = _a.sent();
                    machine = {
                        id: result.id,
                        companyId: result.companyId,
                        companyName: result.companyName,
                        name: result.name,
                        type: result.type,
                        technicians: result.technicians,
                        totalClients: result.totalClients,
                        processedDocuments: result.documents,
                        failedDocuments: 0,
                        processingDocuments: 0,
                        unprocessableDocuments: 0,
                        brand: result.brand,
                        isActive: result.isActive,
                        linkedFrom: []
                    };
                    setTechnicianDrawer({ isOpen: true, machine: machine });
                    return [2 /*return*/];
            }
        });
    }); };
    var handleViewClients = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var result, machine;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, triggerMachineDetail(id).unwrap()];
                case 1:
                    result = _a.sent();
                    machine = {
                        id: result.id,
                        companyId: result.companyId,
                        companyName: result.companyName,
                        name: result.name,
                        type: result.type,
                        technicians: result.technicians,
                        totalClients: result.totalClients,
                        processedDocuments: result.documents,
                        failedDocuments: 0,
                        processingDocuments: 0,
                        unprocessableDocuments: 0,
                        brand: result.brand,
                        isActive: result.isActive,
                        linkedFrom: []
                    };
                    setClientsDrawer({ isOpen: true, machine: machine });
                    return [2 /*return*/];
            }
        });
    }); };
    var handleViewFAQs = function (id) {
        setFAQDrawer({ isOpen: true, machineId: id });
    };
    var handleManageSerialNumbers = function (id) {
        onManageSerialNumbers(id, 'folders');
    };
    var handleEditMachine = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var result, machine;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, triggerMachineDetail(id).unwrap()];
                case 1:
                    result = _a.sent();
                    machine = {
                        id: result.id,
                        companyId: result.companyId,
                        companyName: result.companyName,
                        name: result.name,
                        type: result.type,
                        technicians: result.technicians,
                        totalClients: result.totalClients,
                        processedDocuments: result.documents,
                        failedDocuments: 0,
                        processingDocuments: 0,
                        unprocessableDocuments: 0,
                        brand: result.brand,
                        isActive: result.isActive,
                        linkedFrom: []
                    };
                    handleOpenEditMachine(machine);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleMachineClick = function (machine) {
        onMachineSelect(machine);
    };
    var loadMore = function () {
        dispatch(setFolderViewRequest(__assign(__assign({}, folderViewRequest), { page: AppConsts.DEFAULT_PAGE_NUMBER, pageSize: folderViewRequest.pageSize + AppConsts.DEFAULT_PAGE_SIZE_FOLDER })));
    };
    return (_jsxs(Box, { sx: {
            height: __assign(__assign(__assign(__assign({ xs: 'calc(100svh - 267px)', sm: 'calc(100svh - 375px)' }, (isscreen600900 && { sm: 'calc(100svh - 339px)' })), (isscreen600900Landscape && { sm: '400px' })), (isscreen9001200Landscape
                ? { sm: '420px' }
                : iscreen9001200
                    ? { sm: 'calc( 100svh - 350px)' }
                    : {})), { overflowY: 'auto' })
        }, children: [_jsxs(Grid, { container: true, spacing: 1, px: 0.5, children: [folderDocuments && folderDocuments.totalCount <= 0 && (_jsx(Grid, { size: { xs: 12 }, sx: { textAlign: 'center', mt: 2 }, children: _jsx(Typography, { children: translate('common.noRecordFound') }) })), folderDocuments &&
                        folderDocuments.totalCount > 0 &&
                        folderDocuments.items.length &&
                        folderDocuments.items.map(function (machine) { return (_jsx(Grid, { size: { xs: 12, sm: isscreen600900 ? 12 : 3, md: iscreen9001200 ? 6 : 3 }, children: _jsx(MachineFolderCard, { id: machine.id, title: machine.name, onClick: function () { return handleMachineClick(machine); }, machine: machine, switchChecked: machine.isActive, onSwitchToggle: function () { return handleSwitchToggle(machine); }, onStartChat: handleStartChat, onViewTechnicians: handleViewTechnicians, onViewClients: handleViewClients, onViewFAQs: handleViewFAQs, onManageSerialNumbers: handleManageSerialNumbers, onEditMachine: handleEditMachine }) }, machine.id)); }), folderDocuments && folderDocuments.hasNextPage && (_jsx(Grid, { size: { xs: 12 }, sx: { textAlign: 'center', mt: 2 }, children: _jsx(Button, { variant: 'contained', onClick: loadMore, children: isFetching
                                ? translate('common.loading')
                                : translate('common.loadMore', {
                                    count: Math.max(folderDocuments.totalCount - folderDocuments.items.length, 0)
                                }) }) }))] }), _jsx(ActivationDialog, { open: dialogOpen, onClose: function () { return setDialogOpen(false); }, onConfirm: handleConfirmToggle, machineName: (selectedMachine === null || selectedMachine === void 0 ? void 0 : selectedMachine.name) || '', isActivating: isActivating }), _jsx(FolderQuickView, { open: quickViewDilaogOpen, onClose: function () { return setQuickViewDialogOpen(false); }, machineName: (selectedMachine === null || selectedMachine === void 0 ? void 0 : selectedMachine.name) || '', manualCount: 0, modelCount: (_b = selectedMachine === null || selectedMachine === void 0 ? void 0 : selectedMachine.modelCount) !== null && _b !== void 0 ? _b : 0, documentCount: (_c = selectedMachine === null || selectedMachine === void 0 ? void 0 : selectedMachine.totalDocumentCount) !== null && _c !== void 0 ? _c : 0, serialNumberCount: (_d = selectedMachine === null || selectedMachine === void 0 ? void 0 : selectedMachine.serialNumberCount) !== null && _d !== void 0 ? _d : 0, isShowModelNumber: false })] }));
};
export default MachineFolders;
